export default {
	dashboard: "Tableau de bord",
	users: "Utilisateurs",
	consultants: "Consultants",
	mediums: "Médiums",
	functions: "Fonctions",
	spiritualLines: "Lignes spirituelles",
	guides: "Guides spirituels",
	orixas: "Orixás",
	ritualTypes: "Types de rituels",
	rituals: "Rituels",
	journeyStages: "Étapes du parcours",
	logout: "Déconnexion",
	wisdomQuotes: "Citations de sagesse",
	import: "Importer",
	billing: "Mon forfait",
	manual: "Manuel",
	support: "Support",
	attendanceTypes: "Types de présence",
	displayMessages: "Affichage / TV",
	templeInvites: "Invitations",
	templeSettings: "Paramètres",
};
